export default __webpack_public_path__ + "static/media/profile-settings.692854a5.svg";